<script>
	import { onMount } from "svelte";
	const myPost = {
		module: "core", method: "getTimeout", cName: "loginstate"
	};

	let seconds;
	let formatted;
	let duration;
	const options = {
	  method: 'POST',
	  body: "module=core&method=getTimeout&cName=loginstate",

	  headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		}
	};


	const url = "/core/application/ajaxDispatcher.php";

	onMount(async function() {
		let res = await fetch(url, options);
		const text = await res.json();
		seconds = parseInt(text);
		setInterval(function () {
			seconds = seconds - 1;
			duration = moment.duration(seconds, 'seconds');
			if (seconds === 0) {
				window.location = "/logout";
			}
			formatted = duration.format("hh:mm:ss");
		}, 1000);


	});




</script>

<main>


		{#if formatted===undefined}

			<p></p>

		{:else}
		<div class="well sessionTimeout">
			{#await formatted}

				<p>Loading...</p>

			{:then value}

				<div class="logoutTitle">Automatischer Logout in:</div>
				<div class="logoutTimer">{formatted} Minuten</div>
			{/await}
		</div>
		{/if}

</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0  auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>